export const templatePersonas = [
  {
    Code: '05',
    Name: 'Organogram 1',
    Type: 'organogram',          
  },
  {
    Code: '05.05',
    Name: 'Persona 1',
    Type: 'persona',
    Variations: `{"seniority":"junior","level":"1","fte_cost":"10.0"};\n{"seniority":"mid","level":"10","fte_cost":"10.0"};\n{"seniority":"senior","level":"1","fte_cost":"10.0"};\n{"seniority":"specialist","level":"10","fte_cost":"10.0"}`,
    Specialties: `Frontend;\nBackend;\nDevops;\nTester`
  },
  {
    Code: '05.10',
    Name: 'Persona 2',
    Type: 'persona',
    Variations: `{"seniority":"junior","level":"1","fte_cost":"10.0"};\n{"seniority":"mid","level":"10","fte_cost":"10.0"};\n{"seniority":"senior","level":"1","fte_cost":"10.0"};\n{"seniority":"specialist","level":"10","fte_cost":"10.0"}`,
    Specialties: `Frontend;\nBackend;\nDevops;\nTester`
  },
  {
    Code: '10',
    Name: 'Organogram 2',
    Type: 'organogram',
  },
  {
    Code: '10.05',
    Name: 'Organogram 2.1',
    Type: 'organogram',
  },
  {
    Code: '10.10',
    Name: 'Persona 1',
    Type: 'persona',
    Variations: `{"seniority":"junior","level":"1","fte_cost":"10.0"};\n{"seniority":"mid","level":"10","fte_cost":"10.0"};\n{"seniority":"senior","level":"1","fte_cost":"10.0"};\n{"seniority":"specialist","level":"10","fte_cost":"10.0"}`,
    Specialties: `Frontend;\nBackend;\nDevops;\nTester`
  }
];


export const templateTechnologies = [
    {
      Code: '05',
      Name: 'ERP 1',
      Version: '-',
      Date_installation: '-',
      Manufacturer: '-',
      Specification: '-',
      Description: 'Description'
    },
    {
      Code: '05.05',
      Name: 'Module 1',
      Version: 'Version',
      Date_installation: 'MM/AA',
      Manufacturer: 'Manufacturer',
      Specification: 'Specification',
      Description: 'Description'
    },
    {
      Code: '05.10',
      Name: 'Module 2',
      Version: 'Version',
      Date_installation: 'MM/AA',
      Manufacturer: 'Manufacturer',
      Specification: 'Specification',
      Description: 'Description'
    },
    {
      Code: '10',
      Name: 'ERP 2',
      Version: '-',
      Date_installation: '-',
      Manufacturer: '-',
      Specification: '-',
      Description: 'Description'
    },
    {
      Code: '10.05',
      Name: 'Module 1',
      Version: 'Version',
      Date_installation: 'MM/AA',
      Manufacturer: 'Manufacturer',
      Specification: 'Specification',
      Description: 'Description'
    },
]

export const templateBusinessSolutions = [
    {
      Code: '05',
      Name: 'Jornada 1',
      Status: 'new',
      Description: 'Description',
      Procedures: 'Procedure 1; Procedure 2',
      Integrations: 'Integration 1; Integration 2',
      FAQ: 'Question 1; Question 2'
    },
    {
      Code: '05.05',
      Name: 'Macro Processo 1',
      Status: 'new',
      Description: 'Description',
      Procedures: 'Procedure 1; Procedure 2',
      Integrations: 'Integration 1; Integration 2',
      FAQ: 'Question 1; Question 2'
    },
    {
      Code: '05.05.05',
      Name: 'Processo 1',
      Status: 'new',
      Description: 'Description',
      Procedures: 'Procedure 1; Procedure 2',
      StrategicPlanning: `{"organization": "Organization 1", "name": "Name 1", "action": "Action 1", "result": "Result 1", "date": "dd/mm/aaaa"}`,
      Contacts: `{"name": "Contato 1", "type": "", "area": "", "function": "", "email": "teste1@teste.com", "phone": "(99) 99999-9999"},{"name": "Contato 2", "type": "Compradores", "area": "Logística", "function": "CMO", "email": "teste2@teste.com", "phone": "(99) 99999-9999"}`,
      Integrations: 'Integration 1; Integration 2',
      FAQ: 'Question 1; Question 2'
    },
    {
      Code: '05.05.05.05',
      Name: 'Sub Processo 1',
      Status: 'new',
      Description: 'Description',
      Procedures: 'Procedure 1; Procedure 2',
      Contacts: `{"name": "Contato 1", "type": "", "area": "", "function": "", "email": "teste1@teste.com", "phone": "(99) 99999-9999"},{"name": "Contato 2", "type": "Compradores", "area": "Logística", "function": "CMO", "email": "teste2@teste.com", "phone": "(99) 99999-9999"}`,
      Phase: `{"weeks_quantity":"0","entryDate":"2025-05-30T03:00:00.000Z","organizationResponsible":"Responsável 1","weeks":[{"date":"30/05/2025","week":"1","observation":"Demanda 1","percentage":"2","phase":"potential-demand"},{"date":"06/06/2025","week":"2","observation":"Demanda 2","percentage":"4","phase":"potential-demand"}]}`,
      FteTab: `{"start_date": "2025-05-21T03:00:00.000Z", "end_date": "2025-05-29T03:00:00.000Z", "arbitrary_value": "1", "real_value": "2", "isSap": "no", "months": [{"month":"Maio","fte":"2","observation":"teste observação 1"},{"month":"Junho","fte":"4","observation":"teste observação 2"}]}`,
      Integrations: 'Integration 1; Integration 2',
      FAQ: 'Question 1; Question 2'
    },
    {
      Code: '05.10',
      Name: 'Macro Processo 2',
      Status: 'new',
      Description: 'Description',
      Procedures: 'Procedure 1; Procedure 2',
      Integrations: 'Integration 1; Integration 2',
      FAQ: 'Question 1; Question 2'
    },
    {
      Code: '10',
      Name: 'Jornada 2',
      Status: 'new',
      Description: 'Description',
      Procedures: 'Procedure 1; Procedure 2',
      Integrations: 'Integration 1; Integration 2',
      FAQ: 'Question 1; Question 2'
    },
    {
      Code: '10.05',
      Name: 'Macro Processo 1',
      Status: 'new',
      Description: 'Description',
      Procedures: 'Procedure 1; Procedure 2',
      Integrations: 'Integration 1; Integration 2',
      FAQ: 'Question 1; Question 2'
    },
]

export const templateCrmTree = [
    {
      Code: '05',
      Name: 'OPERAÇÃO',
      Status: 'new',
      Description: 'Description',
    },
    {
      Code: '05.05',
      Name: 'OPORTUNIDADES POR CLIENTES',
      Status: 'new',
      Description: 'Description',
    },
    {
      Code: '05.05.05',
      Name: 'CLIENTE 1',
      Status: 'new',
      Description: 'Description',
      StrategicPlanning: `{"organization": "Organization 1", "name": "Name 1", "action": "Action 1", "result": "Result 1", "date": "dd/mm/aaaa"}`,
      Contacts: `{"name": "Contato 1", "type": "", "area": "", "function": "", "email": "teste1@teste.com", "phone": "(99) 99999-9999"},{"name": "Contato 2", "type": "Compradores", "area": "Logística", "function": "CMO", "email": "teste2@teste.com", "phone": "(99) 99999-9999"}`,
    },
    {
      Code: '05.05.05.05',
      Name: 'OPORTUNIDADE 001',
      Status: 'new',
      Description: 'Description',
      Contacts: `{"name": "Contato 1", "type": "", "area": "", "function": "", "email": "teste1@teste.com", "phone": "(99) 99999-9999"},{"name": "Contato 2", "type": "Compradores", "area": "Logística", "function": "CMO", "email": "teste2@teste.com", "phone": "(99) 99999-9999"}`,
      Phase: `{"weeks_quantity":"0","entryDate":"2025-05-30T03:00:00.000Z","organizationResponsible":"Responsável 1","weeks":[{"date":"30/05/2025","week":"1","observation":"Demanda 1","percentage":"2","phase":"potential-demand"},{"date":"06/06/2025","week":"2","observation":"Demanda 2","percentage":"4","phase":"potential-demand"}]}`,
      FteTab: `{"start_date": "2025-05-21T03:00:00.000Z", "end_date": "2025-05-29T03:00:00.000Z", "arbitrary_value": "1", "real_value": "2", "isSap": "no", "months": [{"month":"Maio","fte":"2","observation":"teste observação 1"},{"month":"Junho","fte":"4","observation":"teste observação 2"}]}`,
    },
    {
      Code: '05.05.05.10',
      Name: 'OPORTUNIDADE 002',
      Status: 'new',
      Description: 'Description',
      Contacts: `{"name": "Contato 1", "type": "", "area": "", "function": "", "email": "teste1@teste.com", "phone": "(99) 99999-9999"},{"name": "Contato 2", "type": "Compradores", "area": "Logística", "function": "CMO", "email": "teste2@teste.com", "phone": "(99) 99999-9999"}`,
      Phase: `{"weeks_quantity":"0","entryDate":"2025-05-30T03:00:00.000Z","organizationResponsible":"Responsável 1","weeks":[{"date":"30/05/2025","week":"1","observation":"Demanda 1","percentage":"2","phase":"potential-demand"},{"date":"06/06/2025","week":"2","observation":"Demanda 2","percentage":"4","phase":"potential-demand"}]}`,
      FteTab: `{"start_date": "2025-05-21T03:00:00.000Z", "end_date": "2025-05-29T03:00:00.000Z", "arbitrary_value": "1", "real_value": "2", "isSap": "no", "months": [{"month":"Maio","fte":"2","observation":"teste observação 1"},{"month":"Junho","fte":"4","observation":"teste observação 2"}]}`,
    },
    {
      Code: '05.05.10',
      Name: 'CLIENTE 2',
      Status: 'new',
      Description: 'Description',
      StrategicPlanning: `{"organization": "Organization 1", "name": "Name 1", "action": "Action 1", "result": "Result 1", "date": "dd/mm/aaaa"}`,
      Contacts: `{"name": "Contato 1", "type": "", "area": "", "function": "", "email": "teste1@teste.com", "phone": "(99) 99999-9999"},{"name": "Contato 2", "type": "Compradores", "area": "Logística", "function": "CMO", "email": "teste2@teste.com", "phone": "(99) 99999-9999"}`,
    },
    {
      Code: '05.05.10.05',
      Name: 'OPORTUNIDADE 001',
      Status: 'new',
      Description: 'Description',
      Contacts: `{"name": "Contato 1", "type": "", "area": "", "function": "", "email": "teste1@teste.com", "phone": "(99) 99999-9999"},{"name": "Contato 2", "type": "Compradores", "area": "Logística", "function": "CMO", "email": "teste2@teste.com", "phone": "(99) 99999-9999"}`,
      Phase: `{"weeks_quantity":"0","entryDate":"2025-05-30T03:00:00.000Z","organizationResponsible":"Responsável 1","weeks":[{"date":"30/05/2025","week":"1","observation":"Demanda 1","percentage":"2","phase":"potential-demand"},{"date":"06/06/2025","week":"2","observation":"Demanda 2","percentage":"4","phase":"potential-demand"}]}`,
      FteTab: `{"start_date": "2025-05-21T03:00:00.000Z", "end_date": "2025-05-29T03:00:00.000Z", "arbitrary_value": "1", "real_value": "2", "isSap": "no", "months": [{"month":"Maio","fte":"2","observation":"teste observação 1"},{"month":"Junho","fte":"4","observation":"teste observação 2"}]}`,
    },
]


export const templateWorkflow = [
  {
    Code: '05',
    Name: 'User 1',
    Email: 'user1@email.com',
    Is_available: true
  },
  {
    Code: '05.05',
    Name: 'User 2',
    Email: 'user2@email.com',
    Is_available: true
  },
  {
    Code: '05.10',
    Name: 'User 3',
    Email: 'user3@email.com',
    Is_available: true
  },
  {
    Code: '10',
    Name: 'User 4',
    Email: 'user4@email.com',
    Is_available: true
  },
]
